export const my_portal_parts_table = {
  col_photo: "Photo",
  col_part_number: "Part Number",
  col_part_type: "Part Type",
  col_date_listed: "Date Listed",
  col_date_sold: "Date Sold",
  col_shipped_date: "Shipped Date",
  col_organization: "Organization",
  col_price_sold: "Price Sold",
  col_buyer: "Buyer",
  col_description: "Description",
  col_manufacturer: "Manufacturer",
  col_frame: "Frame",
  col_turbine_model: "Turbine Model",
  col_serial_number: "Serial Number",
  col_upgrades: "Upgrades",
  col_casting_number: "Casting Number",
  col_quantity: "Quantity",
  col_condition: "Condition",
  col_status: "Status",
  col_list_price: "List Price",
  col_matched_hardware: "Matched Hardware",
  col_fired_hours: "Fired Hours",
  col_fired_starts: "Fired Starts",
  col_emergency_trips: "Emergency Trips",
  col_times_refurbished: "Times Refurbished",
  col_tags: "Tags",
  col_address: "Address",
  col_sold_off_platform: "Sold Off Platform",
  col_created_at: "Created",
  col_updated_at: "Updated",
  col_id: "ID",

  yes: "Yes",
  no: "No",

  empty_cell: "—",
  rows_per_page: "Rows per page:",
  items_per_page_all: "All",

  thumb_aria: "View details for {partNumber}",
  thumb_alt: "Thumbnail for {partNumber}",
};
